import IntlMessage from '../HVUI/IntlMessage/IntlMessage';
import {
    doesNotContainNumericChars,
    isEmailWithMessage,
    isPhoneWithMessage,
    isReasonableDateWithMessage,
    isStrongPasswordWithMessage,
    isValidBirthdayWithMessage,
    matchesWithMessage,
    maxLengthNotRequiredWithMessage,
    maxLengthWithMessage,
    maxValueWithMessage,
    minLengthNotRequiredWithMessage,
    minLengthWithMessage,
    minValueWithMessage,
    notEmptyWithMessage,
    onlyExclusiveValuesWithMessage
} from './Validator';

// override the normal redux validators w/ IntlMessages
export const notEmpty = notEmptyWithMessage(
    <IntlMessage id="all.required" defaultMessage="Required" />
);

export const noNumericChars = doesNotContainNumericChars(
    <IntlMessage id="all.no-numeric-chars" defaultMessage="Cannot contain numbers" />
);

export const isEmail = isEmailWithMessage(
    <IntlMessage
        id="all.must-be-valid-email-address"
        defaultMessage="Must be a valid email address"
    />
);

export const matches = matchesWithMessage(
    <IntlMessage id="all.must-match" defaultMessage="Must match" />
);

export const isPhone = isPhoneWithMessage({
    required: <IntlMessage id="all.required" defaultMessage="Required" />,
    invalid: (
        <IntlMessage
            id="all.please-enter-a-valid-phone-number"
            defaultMessage="Please enter a valid phone number"
        />
    )
});

export const isValidBirthday = isValidBirthdayWithMessage({
    low: [
        <IntlMessage id="all.over" defaultMessage="over" key="0" />,
        <IntlMessage id="all.years-old" defaultMessage="years old" key="1" />
    ],
    high: (
        <IntlMessage
            id="all.less-than-years-old"
            defaultMessage="less than 123 years old"
        />
    ),
    i18n: true
});

export const isStrongPassword = isStrongPasswordWithMessage({
    strength: (
        <IntlMessage
            id="all.password-must-be-stronger"
            defaultMessage="Password must be stronger"
        />
    ),
    length: (
        <IntlMessage
            id="all.password-must-be-at-least-characters"
            defaultMessage="Password must be at least 8 characters"
        />
    )
});

export const maxValue = maxValueWithMessage(max => (
    <IntlMessage
        id="all.must-be-less-than"
        defaultMessage="Must be less than {num}."
        values={{ num: max }}
    />
));

export const maxLength = maxLengthWithMessage({
    formatter: max => (
        <IntlMessage
            id="all.must-be-less-than-characters"
            defaultMessage="Must be less than {num} characters."
            values={{ num: max }}
        />
    ),
    feedback: {
        required: <IntlMessage id="all.required" defaultMessage="Required" />
    }
});

export const maxLengthNotRequired = maxLengthNotRequiredWithMessage(max => (
    <IntlMessage
        id="all.must-be-less-than-characters"
        defaultMessage="Must be less than {num} characters."
        values={{ num: max }}
    />
));

export const minValue = minValueWithMessage(min => (
    <IntlMessage
        id="all.must-be-at-least"
        defaultMessage="Must be at least {num}."
        values={{ num: min }}
    />
));

export const minLength = minLengthWithMessage({
    formatter: min => (
        <IntlMessage
            id="all.must-be-at-least-characters"
            defaultMessage="Must be at least {num} characters."
            values={{ num: min }}
        />
    ),
    feedback: {
        required: <IntlMessage id="all.required" defaultMessage="Required" />
    }
});

export const minLengthNotRequired = minLengthNotRequiredWithMessage(min => (
    <IntlMessage
        id="all.must-be-at-least-characters"
        defaultMessage="Must be at least {num} characters."
        values={{ num: min }}
    />
));

export const onlyExclusiveValues = onlyExclusiveValuesWithMessage({
    i18n: true,
    multiple: (
        <IntlMessage
            id="all.cant-choose-at-the-same-time"
            defaultMessage="Can't choose at the same time:"
        />
    ),
    cantCombine: (
        <IntlMessage id="all.cant-combine" defaultMessage="Can't combine" />
    ),
    andOther: (
        <IntlMessage
            id="all.and-other-choices"
            defaultMessage="and other choices"
        />
    )
});

export const isReasonableDate = isReasonableDateWithMessage({
    i18n: true,
    high: <IntlMessage id="all.more-recent" defaultMessage="more recent" />,
    low: <IntlMessage id="all.a-valid-date" defaultMessage="a valid date" />
});
